import { DownloadOutlined } from '@ant-design/icons';
import Toast from 'components/Shared/Toast';
import { IParticipantData } from 'interfaces/attendanceList';
import React, { useContext } from 'react';
import ticketService from 'services/ticket';

import PrintContext from './context';
import * as S from './styles';
import { Row, Col, Button, Typography, QRCode } from 'antd';
import { EventDates } from 'interfaces/event';
import { printTicket } from './print';
import { formatDate } from 'helpers/date';

interface TicketProps {
  participantData: IParticipantData;
}

const { Title, Text } = Typography;

const Ticket = ({ participantData }: TicketProps) => {
  const {
    attendance_id,
    document: participantDocument,
    event_id,
    fat_cod,
    invite_key,
    invite_url,
    image_path,
    lot_name,
    name,
    place,
    ticket_name,
    title,
    type,
    event_dates,
    custom_fields,
  } = participantData;

  const { isPrinting } = useContext(PrintContext);

  const formatEventDate = (eventDate: EventDates) => {
    const date = formatDate(eventDate.date, 'dd/MM/yyyy');
    return `Dia ${date} das ${eventDate.start_time} às ${eventDate.end_time}`;
  };

  const downloadTicket = (eventId: string, attendanceId: string) => {
    ticketService.printPublic(eventId, attendanceId).subscribe({
      next: result => {
        const linkSource = `data:application/pdf;base64,${result.pdf}`;
        const downloadLink = document.createElement('a');
        downloadLink.href = linkSource;
        downloadLink.download = `ticket_${attendanceId}.pdf`;
        downloadLink.click();
      },
      error: () => {
        Toast.error('Ocorreu um erro para efetuar o download');
      },
    });
  };

  return (
    <div>
      <Row>
        <Col span={24}>
          <Title level={5}>{ticket_name}</Title>
        </Col>
      </Row>

      <Row>
        <Col span={24} id={`print-${invite_key}`}>
          <S.TicketWrapper className='ticket-wrapper'>
            <Col span={24}>
              <Row gutter={16} className='event-info'>
                <Col>
                  <img
                    alt='imagem do evento'
                    className='event-image'
                    style={{ width: '100%', height: 'auto', minHeight: '120px', maxWidth: '140px' }}
                    src={`${process.env.REACT_APP_CDN_URL}${image_path}`}
                  />
                </Col>
                <Col>
                  <S.TextWrapper className='text-wrapper'>
                    <Title level={5} className='event-title'>{`${title} - ${lot_name}`}</Title>
                    <Text>Data do evento:</Text>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      {event_dates.map(eventDate => (
                        <Text key={eventDate.id}>{formatEventDate(eventDate)}</Text>
                      ))}
                    </div>
                    <Text>{`Local do evento: ${place ? place : type}`}</Text>
                  </S.TextWrapper>
                </Col>
              </Row>
            </Col>

            <Row justify='space-between' style={{ marginTop: '16px' }} className='participant-info'>
              <Col>
                <S.TextWrapper className='text-wrapper'>
                  {fat_cod && <Text>{`Fatura: ${fat_cod}`}</Text>}
                  <Text>{`Nome: ${name}`}</Text>
                  <Text>{`Documento: ${participantDocument}`}</Text>
                  <Text>{`Nº Ingresso: ${invite_key}`}</Text>
                  {custom_fields &&
                    custom_fields.map(field => <Text key={field.label}>{`${field.label}: ${field.value}`}</Text>)}
                </S.TextWrapper>
              </Col>

              <Col>
                <QRCode value={invite_url || ''} size={220} bordered={false} />
              </Col>
            </Row>
          </S.TicketWrapper>
        </Col>
      </Row>

      <Row>
        <Col span={24} className={isPrinting && 'noprint2'}>
          <Row justify='end' gutter={8}>
            {participantDocument && name && (
              <Col>
                <Button onClick={() => printTicket(invite_key)}>Imprimir</Button>
              </Col>
            )}

            {participantDocument && name && (
              <Col>
                <Button type='primary' onClick={() => downloadTicket(event_id, attendance_id)}>
                  <DownloadOutlined />
                  Baixar ingresso
                </Button>
              </Col>
            )}
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default Ticket;
